import React, { useState } from "react";
import "./Modal.scss";
import { reactLocalStorage } from "reactjs-localstorage";
import config, { getHeaders } from "../config";
import Loader from "../commonComponents/Loader";
import { useHistory } from "react-router-dom";
import { logEventHome } from "../Analytics/AnalyticsEvent";
import { screen } from "../Analytics/EventName";

const ConfirmPopup = ({
  btnColor,
  cancelText,
  message,
  showConfirmModal,
  setShowConfirmModal,
}) => {
  const [loader, setLoader] = useState(false);
  const [scucessModal, setSuccesModal] = useState(false);
  const [response, setResponse] = useState("");
  const history = useHistory();
  const handleLoader=()=>
  {
    console.log("loader function")
    setLoader(false)
  }
  const handleBtnClick=async()=> {
    try{
    setLoader(true);
    const url = `${config.get("base")}${config.get("unsubscribe")}`;
    const response=await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        uid: reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : "",
      }),
      headers:getHeaders()
    })
    if (!response.ok) {
      console.log("API request failed with status:");
      return;
    }
    const result = await response.json();
          logEventHome(
            {
              screen: screen.unsubPage,
              event: "unsub_api_success",
            },
            {
              status: result.status ? result.status : "NA",
              uid: reactLocalStorage.get("uid")
                ? reactLocalStorage.get("uid")
                : "",
            }
          );
          setResponse(result.message);
          checksub();
          // setLoader(false);
          setShowConfirmModal(false)
          if (result.status == "failed") {
            setSuccesModal(false);
          } else {
            setSuccesModal(true);
          }
          reactLocalStorage.set(
            "show_un_sub",
            JSON.stringify(result.showUnsub)
          );
    }catch (error) {
      console.error("Error checking sub:", error);
    }
  }
  const checksub = async (uid) => {
    try {
      setLoader(true);
      const url = `${config.get('base')}${config.get('checkSub')}`
      const uid = reactLocalStorage.get("uid")
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ uid: uid }),
        headers: getHeaders(),
      });

      if (!response.ok) {
        console.log("API request failed with status:", response.status);
        return;
      }
      const result = await response.json();
      setShowConfirmModal(false);
      reactLocalStorage.set("subStatus", result.subStatus);
      reactLocalStorage.set("status_display", result.status_display);
      reactLocalStorage.set("showUnsub", result.showUnsub);
      reactLocalStorage.set("msisdn", result.msisdn);
      reactLocalStorage.set("unsubtext", result.unsub_msg_txt);
      reactLocalStorage.set("status", result.status);
      reactLocalStorage.set("showUnsub", result.showUnsub);
      logEventHome(
        {
          screen: screen.homePage,
          event: "checksub_api_success",
        },
        {
          others: {
            status: result.subStatus ? result.subStatus : "",
            uid: uid ? uid : "NA",
          },
        }
      );
    
    } catch (error) {
      setLoader(false);
      console.error("Error checking sub:", error);
    }
  };

  // const checksub = () => {
  //   const url = `${config.get("base")}${config.get("checkSub")}`;
  //   const uid = reactLocalStorage.get("uid")
  //     ? reactLocalStorage.get("uid")
  //     : "";
  //   fetch(url, {
  //     method: "POST",
  //     body: JSON.stringify({ uid: uid }),
  //     headers: config.get("headers"),
  //   })
  //     .then((res) => {
  //       if (!res.ok) {
  //         throw res;
  //       }
  //       return res.json();
  //     })
  //     .then(
  //       (result) => {
  //         setLoader(false);
  //         setShowConfirmModal(false);
  //         console.log("result message::", result);
  //         reactLocalStorage.set("subStatus", result.subStatus);
  //         reactLocalStorage.set("status_display", result.status_display);
  //         reactLocalStorage.set("msisdn", result.msisdn);
  //         reactLocalStorage.set("unsub_text", result.unsub_msg_txt);
  //         reactLocalStorage.set("showUnsub", result.showUnsub);
  //       },
  //       (error) => {
  //         setLoader(false);
  //         console.log("error:::", error);
  //       }
  //     );
  // };

  return (
    <>
      {showConfirmModal && (
        <div className="modal-bg">
          <div className="model-content">
            <h1 className="text-center bold display align-center justify-center">
              Voulez-vous vraiment vous désinscrire ?
            </h1>
            <button
              className="modalbtn margin text-white capitailize"
              onClick={() => {
                setShowConfirmModal(false);
              }}
              style={{ background: btnColor }}
            >
              {cancelText ? cancelText : "Annuler"}
            </button>
            <button
              className="modalbtn text-white"
              onClick={handleBtnClick}
              style={{ background: btnColor }}
            >
              D'accord
            </button>
          </div>
        </div>
      )}
      {scucessModal && (
        <div className="modal-bg">
          <div className="model-content">
            <h1 className=" bold">{response ? response : "Fait"}</h1>
            {/* <button className='modalbtn margin text-white' onClick={()=>{setShowConfirmModal(false)}} style={{background:btnColor}}>{cancelText?cancelText:"Cancel"}</button> */}
            <button
              className="modalbtn text-white"
              onClick={() => {
                setShowConfirmModal(false);
                history.push("/");
              }}
              style={{ background: btnColor }}
            >
              D'accord
            </button>
          </div>
        </div>
      )}
      {loader && (
        <div className="modal-bg">
          <div className="model-content">
            <h1 className=" bold">Traitement de la demande!</h1>
            <Loader color="black" />
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmPopup;
